"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPatientValidationErrorsForReferral = exports.hasPatientValidationErrorsForBooking = exports.hasPatientValidationErrors = exports.hasErrors = exports.showSpinner = exports.isReferDisabled = exports.hasMaxReferrals = exports.hasReferrals = exports.canBook = exports.canRefer = exports.isInitializing = void 0;
const constants_1 = require("../common/constants");
const isInitializing = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.validatingPostMessageUrl}`,
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.invalidPostMessageUrl}`,
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.sendingPatientRequest}`,
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.requestPatientAwaitingResponse}`,
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.requestPatientFailed}`,
        `${constants_1.CrmConnectorStates.initializing}.${constants_1.CrmConnectorStates.noPatientDataReceived}`
    ].some(state.matches);
};
exports.isInitializing = isInitializing;
const canRefer = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.ready}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.noReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.someReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.maxReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralData}`
    ].some(state.matches);
};
exports.canRefer = canRefer;
const canBook = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.ready}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.sendingBookingData}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.sendingBookingDataError}`
    ].some(state.matches);
};
exports.canBook = canBook;
const hasReferrals = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.someReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.maxReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralData}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralDataError}`
    ].some(state.matches);
};
exports.hasReferrals = hasReferrals;
const hasMaxReferrals = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.maxReferrals}`
    ].some(state.matches);
};
exports.hasMaxReferrals = hasMaxReferrals;
const isReferDisabled = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.noReferrals}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralData}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralDataError}`
    ].some(state.matches);
};
exports.isReferDisabled = isReferDisabled;
const showSpinner = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralData}`
    ].some(state.matches);
};
exports.showSpinner = showSpinner;
const hasErrors = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initializationError}.${constants_1.CrmConnectorStates.displayError}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.sendingReferralDataError}.${constants_1.CrmConnectorStates.displayError}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.sendingBookingDataError}.${constants_1.CrmConnectorStates.displayError}`
    ].some(state.matches);
};
exports.hasErrors = hasErrors;
const hasPatientValidationErrors = (state) => {
    return [
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.invalidPatientData}`,
        `${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.invalidPatientData}`
    ].some(state.matches);
};
exports.hasPatientValidationErrors = hasPatientValidationErrors;
const hasPatientValidationErrorsForBooking = (state) => {
    return state.matches(`${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.booking}.${constants_1.CrmConnectorStates.invalidPatientData}`);
};
exports.hasPatientValidationErrorsForBooking = hasPatientValidationErrorsForBooking;
const hasPatientValidationErrorsForReferral = (state) => {
    return state.matches(`${constants_1.CrmConnectorStates.initialized}.${constants_1.CrmConnectorStates.referral}.${constants_1.CrmConnectorStates.invalidPatientData}`);
};
exports.hasPatientValidationErrorsForReferral = hasPatientValidationErrorsForReferral;
//# sourceMappingURL=util.js.map